export default __webpack_public_path__ + "static/media/sajid-ahmad-zQZ4L9WrCJ8-unsplash.92c98cb3.jpg";